module.exports = __webpack_public_path__ + "17_hair_gold.10ce7ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/17_hair_gold.png
// module id = /FVA
// module chunks = 0